<div class="flex flex-col items-center text-center p-6 space-y-4">
    <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" rel="stylesheet">

    <div class="bg-custom-blue rounded-full h-[95px] w-[95px]  flex items-center justify-center">
        <i class="fas fa-check text-white custom-thick-icon  fa-3x"></i>
    </div>

    <div>
        <h2 class=" text-2xl font-semibold mt-6 font-mulish">Welcome, {{firstNameData}}!</h2>
        <p class="text-lg mt-2 mb-2  font-mulish " style="color: #006A98; ">You're all set! Your registration was
            successful.</p>
    </div>

    @if(!hideButton)
    {
          <div class="w-full">
            <button pButton class="p-button-info rounded-lg w-full mt-6 flex items-center justify-center gap-2"
                [rounded]="true" (click)="onClickStart()">
                <i class="fas fa-heart text-lg"></i>
                <span class="flex-1 text-center font-medium font-mulish text-base">Start Fundraising</span>
            </button>
        </div>
    }@else {
        <div class="w-full">
            <button pButton class="p-button-info rounded-lg w-full mt-6 flex items-center justify-center gap-2"
                [rounded]="true" (click)="onClose()">
                <span class="flex-1 text-center font-medium font-mulish text-base">Close</span>
            </button>
        </div>
    }
  
</div>